import { render } from "./index.vue?vue&type=template&id=77ee2dde&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=77ee2dde&lang=scss&scoped=true"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77ee2dde"]])

export default __exports__